import { Accent } from '@/lib/components';
import { IdentifierCategory } from '@/lib/types/enums';
import { Relation } from '@/lib/types/user';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface RelationSummaryProps {
  relation: Relation;
}

export const RelationSummary: React.FunctionComponent<RelationSummaryProps> = ({
  relation,
}) => {
  const { t } = useTranslation();

  const getIdentifierTypeText = (category?: IdentifierCategory) => {
    if (category === IdentifierCategory.COC) {
      return 'KVK-nummer';
    }

    if (category === IdentifierCategory.VAT) {
      return 'BTW-nummer';
    }

    return 'Klant-nummer';
  };

  const labelStyle: React.CSSProperties = { whiteSpace: 'nowrap' };

  const contentStyle: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'minmax(110px, max-content) minmax(0, 1fr)',
    columnGap: 12,
    rowGap: 8,
    width: '100%',
    alignItems: 'start',
  };

  return (
    <div style={contentStyle}>
      <Accent color="primary" type="strong" style={labelStyle}>
        {t('relation.name')}
      </Accent>
      <Accent type="p">{relation.name}</Accent>

      <Accent color="primary" type="strong" style={labelStyle}>
        {t('relation.address')}
      </Accent>
      <Accent type="p">
        {relation?.street} {relation?.houseNumber}, {relation?.city}
      </Accent>

      <Accent color="primary" type="strong" style={labelStyle}>
        {t('relation.zipcode')}
      </Accent>
      <Accent type="p">{relation?.zipcode}</Accent>

      <Accent color="primary" type="strong" style={labelStyle}>
        {t('relation.identifiers')}
      </Accent>
      <div>
        {(relation.identifiers || []).map((relationIdentifier) => {
          const typeText = getIdentifierTypeText(relationIdentifier.category);
          const identifierKey = `${relationIdentifier.category}-${relationIdentifier.identifier}-${relationIdentifier.identifierType || ''}`;

          return (
            <Accent type="p" key={identifierKey}>
              {relationIdentifier.identifier} - {typeText}
            </Accent>
          );
        })}
      </div>
    </div>
  );
};
